import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { DatePipe } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import {
  DialogIPPrefixesComponent,
  DialogIPPrefixesInput,
} from "../../../../components/dialogs/dialog-ip-prefixes/dialog-ip-prefixes";
import { AuthService } from "../../../../services/authservice";
import { Prefix } from "../../ip-prefixes.types";

@Component({
  selector: "[ip-prefix-row]",
  templateUrl: "ip-prefix-row.html",
  styleUrl: "ip-prefix-row.scss",
  imports: [AngularSvgIconModule, DatePipe, TranslatePipe],
})
export class IPPrefixRowComponent {
  private dialog = inject(MatDialog);
  private auth = inject(AuthService);

  protected subscription = input.required<Prefix>();

  protected description = computed(() => this.subscription().description);
  protected prefix = computed(() => this.subscription().ipPrefix?.prefix ?? "");
  protected startDate = computed(() => this.subscription().startDate * 1000);
  protected ipSubscriptions = computed(() => this.subscription().ipSubscriptions);
  protected ipSubscriptionsCount = computed(() => this.ipSubscriptions().length);
  private customerId = computed(() => this.subscription().customerId);

  protected ipVersion = computed(() => {
    const afi = this.subscription().ipPrefix?.afi;
    return afi ? "IPv" + afi : "";
  });

  protected canEdit = computed(
    () =>
      this.auth.hasRole(["Infraverantwoordelijke"])
      && this.auth.isSelfServiceEnabled
      && this.auth.isCurrentOrganisation(this.customerId()),
  );

  protected openDialog() {
    const subscription = this.subscription();
    this.openPrefixDialog({
      prefix: subscription,
      linkedSubscriptions: subscription.ipSubscriptions,
      editModus: false,
    });
  }

  protected openAddDialog() {
    const subscription = this.subscription();
    this.openPrefixDialog({
      prefix: subscription,
      linkedSubscriptions: subscription.availableIpSubscriptions,
      editModus: true,
    });
  }

  private openPrefixDialog(data: DialogIPPrefixesInput) {
    this.dialog
      .open(DialogIPPrefixesComponent, { data })
      .afterClosed()
      .subscribe((result: { forceScrollTop: boolean } | undefined) => {
        if (result?.forceScrollTop) window.scrollTo(0, 0);
      });
  }
}
